import { IUserBonusCard } from '@features/auth/api/authApi.type';

function spendableCards(data: unknown): IUserBonusCard[] | undefined {
  if (!Array.isArray(data)) {
    return undefined;
  }
  return (data as IUserBonusCard[]).filter((card) => Number(card.sum) > 0);
}

export default function usableCards(data: unknown): IUserBonusCard[] | undefined {
  return spendableCards(data)?.filter((card) => !card.expired);
}

export function listedCards(data: unknown): IUserBonusCard[] | undefined {
  const cards = spendableCards(data);
  if (cards === undefined) {
    return undefined;
  }
  const active = cards.filter((card) => !card.expired);
  const expired = cards
    .filter((card) => card.expired)
    .sort((a, b) => Number(b.expiresAt || 0) - Number(a.expiresAt || 0));
  return [ ...active, ...expired ];
}
